export default __webpack_public_path__ + "img/tremors/tremors5_700.webp";